module.exports = __webpack_public_path__ + "img/98.b1c39ec0.jpg";